import React, { useState } from "react";
import { useSelector } from "react-redux";
import { jsPDF } from "jspdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const LegendDB = () => {
  const authState = useSelector((state) => state.authReducer);
  const [certificateNumber, setCertificateNumber] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (certificateNumber.length !== 16) {
      setIsError(true);
      setMessage("❌ Please enter a valid 16-character Certificate Number.");
      setCertificateData(null);
      return;
    }

    const mockCertificate = {
      certificateNumber,
      companyName: "Self",
      name: "Hemant Kumar",
      registrationDate: "2025-10-25",
      validity: "2026-10-24",
      category: "Law Student",
      licenseNumber: "BC-MH-12-0001234",
      location: "Sonarpada, Dombivali East, Maharashtra, India, PIN - 421203",
      status: "Active",
    };

    setCertificateData(mockCertificate);
    setMessage("✅ Certificate Found in Think5Whys Legend Database.");
    setIsError(false);
  };

  const downloadPDF = () => {
    if (!certificateData) return;

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Think5Whys Legend Certificate", 20, 20);
    doc.setFontSize(12);

    const fields = [
      `Certificate Number: ${certificateData.certificateNumber}`,
      `Company Name: ${certificateData.companyName}`,
      `Name: ${certificateData.name}`,
      `Category: ${certificateData.category}`,
      `License Number: ${certificateData.licenseNumber}`,
      `Registration Date: ${certificateData.registrationDate}`,
      `Valid Upto: ${certificateData.validity}`,
      `Status: ${certificateData.status}`,
      `Location: ${certificateData.location}`,
    ];

    fields.forEach((field, i) => doc.text(field, 20, 30 + i * 10));

    doc.save(`Legend_Certificate_${certificateData.certificateNumber}.pdf`);
  };

  return (
    <section className="py-8 px-4 sm:px-6 md:px-20 bg-black min-h-screen flex items-center">
      <div className="bg-black text-white p-8 sm:p-10 rounded-2xl max-w-3xl mx-auto w-full shadow-xl">
        <h3 className="text-xl lg:text-xl font-bold text-yellow-200 mb-2 text-center">
          Think5Whys Googly Database
        </h3>
        <p className="mb-2 text-white text-center">
          Input 16-character Certificate Number to Verify LEGEND Certificate
        </p>

        <form onSubmit={handleSubmit} className="flex justify-center mb-2">
          <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
            <input
              type="text"
              placeholder="Enter Certificate Number"
              value={certificateNumber}
              onChange={(e) => setCertificateNumber(e.target.value.toUpperCase())}
              className="w-full px-4 py-2  text-black border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-center tracking-widest"
              maxLength={16}
            />
            <button
              type="submit"
              className="w-24 mt-4 sm:w-auto px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
            >
              Search
            </button>
          </div>
        </form>

        {message && (
          <p
            className={`mt-2 text-center text-sm font-medium ${
              isError ? "text-red-300" : "text-yellow-200"
            }`}
          >
            {message}
          </p>
        )}

        {certificateData && !isError && (
          <div className="mt-2 bg-black text-white rounded-xl p-6 shadow-inner border border-gray-200">
            <h4 className="text-lg font-semibold text-yellow-200 mb-2 text-center">
              LEGEND Certificate Details
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-white">
              <p className="text-gray-300">
                <strong>Certificate Number:</strong> {certificateData.certificateNumber}
              </p>
              <p className="text-gray-300">
                <strong>Company Name:</strong> {certificateData.companyName}
              </p>
              <p className="text-gray-300">
                <strong>Name:</strong> {certificateData.name}
              </p>
              <p className="text-gray-300">
                <strong>Category:</strong> {certificateData.category}
              </p>
              <p className="text-gray-300">
                <strong>License No:</strong> {certificateData.licenseNumber}
              </p>
              <p className="text-gray-300">
                <strong>Registration Date:</strong> {certificateData.registrationDate}
              </p>
              <p className="text-gray-300">
                <strong>Valid Upto:</strong> {certificateData.validity}
              </p>
              <p className="text-gray-300">
                <strong>Status:</strong>{" "}
                <span className="text-green-600 font-semibold">{certificateData.status}</span>
              </p>
              <p className="sm:col-span-2 text-gray-300">
                <strong>Location:</strong> {certificateData.location}
              </p>
            </div>

            {/* Download PDF Button */}
            <div className="mt-2 flex justify-center">
              <button
                onClick={downloadPDF}
                className="flex items-center gap-2 w-48 px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
              >
                <FontAwesomeIcon icon={faDownload} /> Download PDF
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LegendDB;
